const prefix = 'lumahealth/DialogSavedTemplatesSelector';

export const FORM_NAME = 'DialogSavedTemplatesSelectorForm';

export const SEARCH_SAVED_TEMPLATES = `${prefix}/SEARCH_SAVED_TEMPLATES`;
export const SEARCH_SAVED_TEMPLATES_ERROR = `${prefix}/SEARCH_SAVED_TEMPLATES_ERROR`;
export const SEARCH_SAVED_TEMPLATES_SUCCESS = `${prefix}/SEARCH_SAVED_TEMPLATES_SUCCESS`;
